module.exports = __webpack_public_path__ + "img/251.welcome_you.26d2a670.svg";